var swiper5 = new Swiper(".cryoTeam", {
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
        nextEl: ".team-next",
        prevEl: ".team-prev",
    },
    pagination: {
        el: ".team-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + "</span>";
        },
    },
    breakpoints: {
        0: {
            slidesPerView: 1.53,
            spaceBetween: 15,
        },
        720: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        992: {
            slidesPerView: "auto",
            spaceBetween: 0,
        },
    },
    on: {
        init: function () {
            toggleSwiperTouch(this);
        },
        breakpoint: function () {
            toggleSwiperTouch(this);
        },
    },
});

function toggleSwiperTouch(swiper) {
    if (window.innerWidth >= 992) {
        swiper.allowTouchMove = false;
    } else {
        swiper.allowTouchMove = true;
    }
}
